<div class="header__holder">
  <div class="col-md-4 header-left">
    <div class="header-title">
      <h2>HFSV Partner Organisations</h2>
    </div>
  </div>
  <div class="col-md-4 header-logo">
    <a class="header-logo__link" href="/">
      <img src="assets/images/crest-transparent.png" class="header-logo__image crest" alt="Scottish Fire & Rescue" />
      <img src="assets/images/sfrs-logo-white-on-black.png" class="header-logo__image logo" alt="Scottish Fire & Rescue" />
    </a>
  </div>
</div>
